import React from 'react';
import { Box, Flex, Heading, Text } from '@chakra-ui/react';

const PageShell = ({ title, subtitle, action, children }) => (
  <Box mb={6}>
    <Flex
      direction={{ base: 'column', md: 'row' }}
      align={{ base: 'stretch', md: 'center' }}
      justify="space-between"
      gap={4}
      mb={children ? 6 : 0}
    >
      <Box>
        <Heading
          size="lg"
          fontFamily="heading"
          fontWeight="700"
          letterSpacing="-0.02em"
          color="slate.800"
        >
          {title}
        </Heading>
        {subtitle && (
          <Text mt={1} color="slate.500" fontSize="sm">
            {subtitle}
          </Text>
        )}
      </Box>
      {action && <Box flexShrink={0}>{action}</Box>}
    </Flex>
    {children}
  </Box>
);

export default PageShell;
